/**
 * Konfigurasi menu untuk search di header.
 * Struktur: { label, link, parent } - parent untuk konteks submenu.
 * Items dengan roles: ['super admin'] hanya tampil untuk super admin.
 */
export const MENU_SEARCH_ITEMS = [
  { label: "Dashboard", link: "/template/dashboard", parent: null },
  { label: "Pengaturan peta", link: "/template/pengaturan-peta", parent: null },
  { label: "Profil Saya", link: "/admin/profil", parent: null },
  { label: "Profile", link: "/template/user/profile", parent: "Profil Saya" },
  { label: "Bantuan", link: "/admin/bantuan", parent: null },
  { label: "Jenis bantuan", link: "/admin/bantuan/jenis", parent: "Bantuan" },
  { label: "Data bansos", link: "/admin/bantuan", parent: "Bantuan" },
  { label: "Input Data Bansos", link: "/admin/bantuan/new", parent: "Bantuan" },
  { label: "Penerima", link: "/admin/penerima", parent: null },
  { label: "Data Penerima", link: "/admin/penerima", parent: "Penerima" },
  { label: "Input Data Penerima", link: "/admin/penerima/new", parent: "Penerima" },
  { label: "Upload Penerima", link: "/admin/penerima/upload", parent: "Penerima" },
  { label: "Desil", link: "/template/desil", parent: null },
  { label: "Desa", link: "/template/desil/desa", parent: "Desil" },
  { label: "Kecamatan", link: "/template/desil/kecamatan", parent: "Desil" },
  { label: "Cari Individu", link: "/template/desil/cari-individu", parent: "Desil" },
  { label: "Progres Input", link: "/template/progressinput", parent: null },
  { label: "On Progress", link: "/template/progressinput/onprogress", parent: "Progres Input" },
  { label: "Selesai", link: "/template/progressinput/selesai", parent: "Progres Input" },
  { label: "Semua bantuan", link: "/template/progressinput/semua", parent: "Progres Input" },
  { label: "SK Bupati", link: "/template/progressSK", parent: null },
  { label: "On Progress", link: "/template/progressSK/onprogress", parent: "SK Bupati" },
  { label: "Selesai", link: "/template/progressSK/selesai", parent: "SK Bupati" },
  { label: "Makan Minum", link: "/admin/makan-minum", parent: null },
  { label: "Dashboard Penyerapan", link: "/admin/makan-minum/dashboard", parent: "Makan Minum" },
  { label: "Rekap Belanja Mamin", link: "/admin/makan-minum", parent: "Makan Minum" },
  { label: "Belanja Mami PD", link: "/admin/makan-minum/belanja-pd", parent: "Makan Minum" },
  { label: "Laporan Bulanan PD", link: "/admin/makan-minum/laporan-bulanan", parent: "Makan Minum" },
  { label: "Buat Laporan Bulanan", link: "/admin/makan-minum/laporan-bulanan/new", parent: "Makan Minum" },
  { label: "Evaluasi", link: "/template/evaluasi", parent: null },
  { label: "Evaluasi Penerima", link: "/template/evaluasi/inputevaluasi", parent: "Evaluasi" },
  { label: "Admin", link: "/admin/listadmin", parent: null, roles: ["super admin"] },
  { label: "Admin TF", link: "/admin/listadmin", parent: "Admin", roles: ["super admin"] },
  { label: "Kunci", link: "/admin/kunci", parent: null, roles: ["super admin"] },
  { label: "Kunci Aturan", link: "/admin/kunci/kunciaturan", parent: "Kunci", roles: ["super admin"] },
  { label: "Analitiks", link: "/template/analitik", parent: null },
  { label: "Miskin Ekstrim", link: "/template/analitik/miskinekstrim", parent: "Analitiks" },
  { label: "Fasilitas", link: "/template/analitik/fasilitas", parent: "Analitiks" },
  { label: "Penerima", link: "/template/analitik/penerima", parent: "Analitiks" },
  { label: "Audit logs", link: "/admin/audit-logs", parent: null, roles: ["super admin"] },
];

/**
 * Filter menu berdasarkan query dan peran user.
 * Pencarian case-insensitive pada label dan parent.
 */
export function searchMenuItems(query, userPeran) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return [];

  const filtered = MENU_SEARCH_ITEMS.filter((item) => {
    if (item.roles && item.roles.length > 0) {
      const peran = (userPeran || "").toLowerCase();
      if (!item.roles.some((r) => peran.includes(r.toLowerCase()))) return false;
    }
    const labelMatch = (item.label || "").toLowerCase().includes(q);
    const parentMatch = (item.parent || "").toLowerCase().includes(q);
    return labelMatch || parentMatch;
  });

  return filtered;
}
